/**
 * The offer, as the prototype's `.reco` block: a short label saying WHY this
 * plan, the plan itself at 17px, and what it costs.
 *
 * An earlier pass dropped the label as "a caption for a caption". It is not:
 * it is the only line that gives the offer a reason ("Para no quedarte sin
 * capacidad, amplía a"), and without it the plan name arrives with no argument
 * attached. Restored 2026-08-31 at Fanny's reading of the prototype.
 *
 * NO PRICE, NO BLOCK. A missing price means the catalog fetch has not landed;
 * that is a reason to show nothing, not to draw a tinted frame around a lone
 * plan name — which in `la-acceptance` also reprinted the tier the alert body
 * had already named one line above.
 */
export type tAlertOfferLineProps = {
  /** Why this plan. Omitted when the caller has no reason to give. */
  label?: string | null;
  /** The plan as the customer reads it, e.g. "Lead Agent Growth". */
  plan: string;
  /** The charge sentence, already formatted. Null renders nothing at all. */
  price: string | null;
  /** Distinguishes the three renderers' offers in tests and captures. */
  testId: string;
};

export default function AlertOfferLine(props: tAlertOfferLineProps) {
  if (!props.price) return null;
  return (
    <div className="AlertDetail__Offer" data-testid={props.testId}>
      {props.label ? (
        <p className="AlertDetail__OfferLabel">{props.label}</p>
      ) : null}
      <p className="AlertDetail__OfferPlan">{props.plan}</p>
      <p
        className="AlertDetail__OfferPrice"
        data-testid={`${props.testId}-price`}
      >
        {props.price}
      </p>
    </div>
  );
}
